module.exports = __webpack_public_path__ + "static/media/sampleJourneyBites.03cfb4e6.pdf";